import { useDialog } from '@/plugins/iscool-dialog';
import { inject } from 'vue';
import { useRoute } from 'vue-router';

/**
 * 接口统计 点击按钮
 * @param page_id
 * @param btnName
 * @param share_platform
 */

const statisticClick = (config: any) => {
  const { route, axios, page_id, btnName, share_platform = '' } = config;

  const { sid, feat } = route.query;
  const api = '/api/report/button/event';

  const formData = new FormData();
  formData.append('sid', sid);
  feat && formData.append('feat', feat);
  formData.append('page_id', page_id);
  formData.append('button_name', btnName);
  formData.append('share_platform', share_platform);

  axios.post(api, formData);
};

/**
 * 检查数据是否正确加载
 * @param {Object} res
 */
const checkDataResult = (res: any) => {
  if (res.data && res.data.result_code === 200) {
    return true;
  } else {
    return false;
  }
};

/**
 * 获取dataBody
 * @param res
 */
const getDataBody = (res: any): any => {
  const { $toast } = useDialog();
  const data = res.data;
  let dataBody: any = {};

  if (data) {
    if (data.result_code === 200) {
      dataBody = data.data_body;
    } else if (data.error_body && data.error_body.info) {
      $toast(data.error_body.info);
    }
  }
  return dataBody;
};

/**
 * 获取dataBody并提示错误信息
 * @param res
 */
const getDataBodyAndToast = (res: any) => {
  const data = res.data;
  const { $toast } = useDialog();
  let dataBody: any = {};

  if (data) {
    if (data.result_code === 200) {
      dataBody = data.data_body;
      if (dataBody['msg']) {
        $toast(dataBody['msg']);
      }
    } else if (data.error_body && data.error_body.info) {
      $toast(data.error_body.info);
    }
  }
  return dataBody;
};

/**
 * 设置导航高度
 */
const getNavHeight = () => {
  const route = useRoute();
  const navHeight = route.query.navheight;
  if (navHeight) {
    const aNavHeight = String(navHeight).split(',');
    const sNavHeight = aNavHeight.shift();
    if (sNavHeight) {
      return parseFloat(sNavHeight);
    }
    return 0;
  }
  return 0;
};

const getNavBarHeight = () => {
  const route = useRoute();
  const navHeight = getNavHeight();
  // Ensure statusBarHeight is treated as a string or undefined if not present
  const statusBarHeight: string | undefined = route.query.statusbarheight?.toString();
  if (!statusBarHeight) {
    return 44;
  }

  return navHeight - parseFloat(statusBarHeight);
};

/**
 * 增加body距离
 */
const appendBodyNavHeight = (oEle: any) => {
  // 解决参数重复问题
  // http://localhost:8020?navheight=72,72&navheight=72
  const navHeight = getNavHeight();
  if (navHeight) {
    const oBody = oEle || document.querySelector('body');
    console.log('oBody', oEle);
    if (oBody) {
      oBody.style.paddingTop = `${navHeight}px`;
    }
  }
};

// 是否为iap购买
const checkIap = () => {
  const route = useRoute();
  const path = route.path;
  if ((route.query.iap && route.query.iap.includes('1')) || /iap$/i.test(path)) {
    return true;
  }
  return false;
};

// 检查是否为测试用户
const checkIsTester = async () => {
  const route = useRoute();
  const axios: any = inject('axios');
  const sid = route.query.sid;
  const res = await axios.get('/api/user/by-sid', { params: { sid } });
  const dataBody = getDataBody(res);
  if (dataBody.code == 0) {
    console.log('dataBody:', dataBody);
    if (dataBody.test) {
      return true;
    }
  }
  return false;
};

const useWindow = () => {
  const route = useRoute();
  const windowOpen = (url: any) => {
    const query: any = route.query;
    const sQuery = new URLSearchParams(query);
    let href;
    if (/\?/.test(url)) {
      href = `${url}&${sQuery}`;
    } else {
      href = `${url}?${sQuery}`;
    }
    window.open(href);
  };
  return {
    windowOpen,
  };
};

// 获取url参数
const getUrlQuery = (key: any) => {
  if (typeof key === 'object') {
    return key.pop();
  }
  return key;
};

export {
  checkIsTester,
  checkDataResult,
  statisticClick,
  getDataBody,
  getDataBodyAndToast,
  checkIap,
  appendBodyNavHeight,
  getNavBarHeight,
  getNavHeight,
  useWindow,
  getUrlQuery,
};
